import { render, staticRenderFns } from "./Learn.vue?vue&type=template&id=e3212414&"
import script from "./Learn.vue?vue&type=script&lang=ts&"
export * from "./Learn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports